import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/bet575/images/logo/logoMb.svg';

export default function Index() {
  return <Image src={logo} maxW="100px" />;
}
